import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { sendTrackingRequestAction } from 'client/contexts/Tracking/actions'
import { checkoutIntent } from 'client/contexts/Tracking/events'
import {
  PaymentWorldlineProps,
  PaymentWorldlineConnectedHandlerProps,
  ValidationResult,
} from './types'

const PaymentWorldlineConnected: (
  WrappedComponent: FC<PaymentWorldlineProps>
) => FC<PaymentWorldlineProps> = WrappedComponent => {
  const PaymentWorldlineConnectedHandler: FC<PaymentWorldlineConnectedHandlerProps> = ({
    onSuccess,
    purchaseId = '',
    ...props
  }) => {
    const dispatch = useDispatch()

    const handleValidationSuccess = (result: ValidationResult) => {
      dispatch(
        sendTrackingRequestAction({
          event: checkoutIntent({
            eventName: 'payment_attempt',
            reason: 'payment_details_validation',
            context: 'payment_checkout',
            status: 'OK',
            purchaseId,
            details: 'Payment details validated',
          }),
        })
      )
      if (onSuccess) onSuccess(result)
    }

    const handleValidationError = () => {
      dispatch(
        sendTrackingRequestAction({
          event: checkoutIntent({
            eventName: 'payment_attempt',
            reason: 'payment_details_validation',
            context: 'payment_checkout',
            status: 'KO',
            purchaseId,
            details: 'Error validating payment details',
          }),
        })
      )
    }

    return (
      <WrappedComponent
        {...props}
        onSuccess={handleValidationSuccess}
        onValidationError={handleValidationError}
        purchaseId={purchaseId}
      />
    )
  }

  return PaymentWorldlineConnectedHandler as FC<PaymentWorldlineProps>
}

export default PaymentWorldlineConnected
